import { Component, HostListener, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-scroll-top',
  standalone: true,
  imports: [MatButtonModule, MatIconModule],
  template: `
    @if (visible()) {
    <button mat-fab color="primary" class="scroll-top-btn" (click)="scrollToTop()" aria-label="Scroll to top">
      <mat-icon>arrow_upward</mat-icon>
    </button>
    }
  `,
  styles: [`
    .scroll-top-btn {
      position: fixed; bottom: 1.5rem; right: 1.5rem; z-index: 999;
      opacity: 0.85; transition: opacity 0.2s ease, transform 0.2s ease;
      box-shadow: 0 4px 14px rgba(255, 107, 53, 0.35);
      &:hover { opacity: 1; transform: translateY(-2px); }
    }
  `],
})
export class ScrollTopComponent {
  visible = signal(false);

  @HostListener('window:scroll', [])
  onScroll() {
    this.visible.set(window.scrollY > 400);
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
